import {
  OwnershipTypes,
  SellerListing,
  TitlePossessions,
} from "@/interfaces/listing/SellerListing";

export interface Specs {
  text: string;
  getter: (listing: SellerListing) => unknown;
  value?: string;
}

export type DisplayedSpecs = Pick<Specs, "text" | "value">;

export const SPECS_LIST: Record<string, Specs> = {
  Trim: {
    text: "Trim",
    getter: (listing: SellerListing) => {
      return listing.Trim;
    },
  },
  BodyStyle: {
    text: "Body style",
    getter: (listing: SellerListing) => {
      return listing.BodyStyle;
    },
  },
  Cylinders: {
    text: "Number of cylinders",
    getter: (listing: SellerListing) => {
      return listing.Cylinders;
    },
  },
  ExteriorColor: {
    text: "Exterior color",
    getter: (listing: SellerListing) => {
      return listing.ExteriorColor;
    },
  },
  PrimaryColor: {
    text: "Primary color",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.motorcycle?.primaryColor;
    },
  },
  Doors: {
    text: "Number of doors",
    getter: (listing: SellerListing) => {
      return listing.Doors;
    },
  },
  Vin: {
    text: "VIN",
    getter: (listing: SellerListing) => {
      return listing.vinNumber.toUpperCase();
    },
  },
  TitleType: {
    text: "Title type",
    getter: (listing: SellerListing) => {
      return listing.TitleType;
    },
  },
  MPGe: {
    text: "MPGe",
    getter: (listing: SellerListing) => {
      return listing.mpg;
    },
  },
  MPG: {
    text: "MPG",
    getter: (listing: SellerListing) => {
      return listing.mpg;
    },
  },
  TitleInHand: {
    text: "Title in hand",
    getter: (listing: SellerListing) => {
      let hasTitle = "";

      const titlePossession = listing.ownershipInfo.titlePossession;

      if (
        titlePossession === TitlePossessions.External ||
        titlePossession === TitlePossessions.Lost
      ) {
        return "No";
      }
      if (titlePossession === TitlePossessions.Held) {
        return "Yes";
      }

      if (listing.ownershipInfo.carTitle) {
        hasTitle = listing.ownershipInfo.carTitle ? "Yes" : "No";
      }
      return hasTitle;
    },
  },
  Lien: {
    text: "Outstanding lien",
    getter: (listing: SellerListing) => {
      const ownershipType = listing.ownershipInfo.ownershipType;

      if (
        ownershipType === OwnershipTypes.Leased ||
        ownershipType === OwnershipTypes.Financed
      ) {
        return "Yes";
      }

      if (ownershipType === OwnershipTypes.Owned) {
        return "No";
      }

      return listing.ownershipInfo?.vehicleHaveLien ? "Yes" : "No";
    },
  },
  // ATV
  ATVCategory: {
    text: "Category",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.atv?.category;
    },
  },
  ATVPrimaryColor: {
    text: "Primary Color",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.atv?.primaryColor;
    },
  },
  ATVStarter: {
    text: "Starter",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.atv?.starter;
    },
  },
};
